import { CategoryId_Schema } from "@/services/collection/categories";
import { ApiResponse_ImageNoId_Schema } from "@/services/images";
import { MarketplaceItemId_Schema } from "@/services/marketplace/item";
import { PriceNumeric_Schema } from "@/services/prices/priceSchema";
import { NaturalNumber_Schema } from "@/utilities";
import { z } from "zod";

export const OrderId_Schema = NaturalNumber_Schema;

export enum OrderStatus {
  Created = "created",
  Paid = "paid",
  Packaging = "in_transit",
  Sent = "sent",
  WaitingForConfirmation = "waiting_for_confirmation",
  WaitingForPayout = "waiting_for_payout",
  Finished = "done",
  CancelledRefundPending = "cancelled_refund_pending", // Cancelled - before the refund has been processed
  Cancelled = "cancelled", // Cancelled - the refund was already processed
  UnderDispute = "under_dispute",
}

export const OrderStatus_Schema = z.enum(OrderStatus);

export const OrderProductId_Schema = NaturalNumber_Schema;

export const OrderProduct_Schema = z
  .object({
    id: OrderProductId_Schema,
    category: CategoryId_Schema,
    images: ApiResponse_ImageNoId_Schema.array(),
    quantity: NaturalNumber_Schema,
    discount: PriceNumeric_Schema.nullable(),
    price: PriceNumeric_Schema, // With applied discount
    priceOriginal: PriceNumeric_Schema, // Without applied discount
    name: z.string(),
    marketPlaceItemId: MarketplaceItemId_Schema,
  })
  .transform(({ category, marketPlaceItemId, id, images, quantity, price, priceOriginal, name, discount }) => ({
    id,
    categoryId: category,
    name,
    images,
    quantity,
    priceAfterDiscount: price,
    priceBeforeDiscount: priceOriginal,
    marketplaceItemId: marketPlaceItemId,
    discount,
  }));
